import { useContext, useEffect, useState } from 'react'
import { anchoDelSidebar, disposicionDelPanel, type Disposicion } from './disposicion'
import { SidebarColapsado } from './sidebarEstado'

/**
 * Columna o cajón para el panel del caso, al día con el ancho de la ventana y
 * con el estado del sidebar.
 *
 * La decisión vive en `disposicion.ts`, pura y probada en Node; acá solo se
 * mide. `innerWidth` y no el ancho del contenedor a propósito: es lo mismo que
 * miran los breakpoints de Tailwind (`xl:`), así que la lista, el panel y esta
 * decisión cambian de ancho en el mismo píxel. El sidebar se lee del Layout
 * (`SidebarColapsado`): expandido ocupa 236 px y colapsado 64, y suponer
 * siempre el expandido plegaba el panel con espacio de sobra (DEF-052).
 */
export function useDisposicion(chatMinimo?: number): Disposicion {
  const colapsado = useContext(SidebarColapsado)
  const sidebar = anchoDelSidebar(colapsado)
  const [disposicion, setDisposicion] = useState<Disposicion>(
    () => disposicionDelPanel(window.innerWidth, chatMinimo, sidebar))

  useEffect(() => {
    const medir = () => setDisposicion(disposicionDelPanel(window.innerWidth, chatMinimo, sidebar))
    medir()
    window.addEventListener('resize', medir)
    return () => window.removeEventListener('resize', medir)
  }, [chatMinimo, sidebar])

  return disposicion
}
